import { Ruler, UtensilsCrossed, Sofa, Flame, CalendarClock, Puzzle, Accessibility } from "lucide-react";
import { Reveal } from "./Reveal";

const FACTS = [
  { icon: Ruler, text: "60 m² juhlatila ja hyvin varusteltu avokeittiö — kokonaistilaa noin 95 m²" },
  { icon: UtensilsCrossed, text: "Pöytäpaikat ja astiasto 24 hengelle" },
  { icon: Sofa, text: "Useita pöytiä ja tuoleja, 3 sohvaa ja smart TV" },
  { icon: Flame, text: "Sauna n. 10 hengelle, 3 suihkua, pukuhuone ja 2 WC:tä" },
  { icon: Puzzle, text: "Pelejä, luovia materiaaleja ja joogamattoja harjoituksiin tarvittaessa" },
  { icon: Accessibility, text: "Tila on esteetön" },
  { icon: CalendarClock, text: "Vuokrattavissa arki-iltaisin ja viikonloppuisin (pe–su) — vakiotuntivuorot sovittavissa" },
];

export const Amenities = () => (
  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6" data-testid="amenities-list">
    {FACTS.map(({ icon: Icon, text }, i) => (
      <Reveal as="li" key={text} delay={i * 0.06} className="flex gap-4 items-start">
        <span className="mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#8A9B87]/15 text-[#8A9B87]">
          <Icon size={18} strokeWidth={1.6} />
        </span>
        <span className="text-base text-[#2E2E2C]/80 leading-relaxed">{text}</span>
      </Reveal>
    ))}
  </ul>
);
